// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import FormOutlined from '/Users/junjian/Project/unianx-MyVillageLog/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FormOutlined';
import TableOutlined from '/Users/junjian/Project/unianx-MyVillageLog/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
import SettingOutlined from '/Users/junjian/Project/unianx-MyVillageLog/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SettingOutlined';
export default { FormOutlined, TableOutlined, SettingOutlined };
